import {
  useId,
  ReactNode,
  CSSProperties,
  useRef,
  useState,
  useEffect
} from 'react'
import { createPortal } from 'react-dom'

import './Popover.css'

type PopoverPosition = 'top' | 'bottom' | 'left' | 'right'

interface PopoverProps {
  children: ReactNode
  triggerContent: ReactNode
  buttonClassName?: string
  popoverClassName?: string
  position?: PopoverPosition
}

export default function Popover({
  children,
  triggerContent,
  buttonClassName = '',
  popoverClassName = '',
  position = 'bottom'
}: PopoverProps) {
  const [isMounted, setIsMounted] = useState(false)

  const popoverId = useId()
  const popoverRef = useRef<HTMLDivElement>(null)

  const uniqueAnchorName = `--popover-anchor-${popoverId.replace(/:/g, '')}`
  useEffect(() => {
    setIsMounted(true)
  }, [])

  const handleContentClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement
    if (target.tagName === 'A' || target.closest('a')) {
      popoverRef.current?.hidePopover()
    }
  }

  const trigger = (
    <button
      type="button"
      popoverTarget={popoverId}
      className={`anchor-button ${buttonClassName}`}
      style={{ anchorName: uniqueAnchorName } as CSSProperties}
    >
      {triggerContent}
    </button>
  )

  const content = (
    <div
      ref={popoverRef}
      id={popoverId}
      popover="auto"
      className={`popover ${popoverClassName}`}
      data-position={position}
      style={{ positionAnchor: uniqueAnchorName } as CSSProperties}
      onClick={handleContentClick}
    >
      {children}
    </div>
  )

  return (
    <>
      {trigger}
      {isMounted && createPortal(content, document.body)}
    </>
  )
}
